import {IClientRoute} from '../../../@interfaces/services/Database';
import AbstractModel from './AbstractModel';

export default class ClientRoute extends AbstractModel<IClientRoute> implements IClientRoute {
	name!: string | null;
	path!: string;
	action!: string | null;
	redirect!: string | null;
    permissions!: string | string[] | null;

	protected get table() {
		return this.connection.clientRoutes;
	}
}
